import React from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';

const { Cell } = Table;

const guestName = rowData =>
  [
    get('firstName', rowData) || get('guest.firstname', rowData),
    get('lastName', rowData) || get('guest.lastname', rowData)
  ]
    .filter(Boolean)
    .join(' ')
    .trim();

const GuestNameCell = ({ rowData, ...props }) => (
  <Cell {...props}>{guestName(rowData) || 'N/A'}</Cell>
);

GuestNameCell.propTypes = {
  rowData: PropTypes.shape({})
};

GuestNameCell.defaultProps = {
  rowData: null
};

export default GuestNameCell;
